var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { itemscope: "", itemtype: "http://schema.org/Thing" } },
    [
      _c(
        "div",
        {
          staticClass: "carousel slide col-md-11",
          attrs: { id: "singleItemCarousel", "data-interval": "false" }
        },
        [
          _c(
            "div",
            { staticClass: "carousel-inner" },
            _vm._l(_vm.allImagesForPicture, function(image, index) {
              return _c(
                "div",
                {
                  staticClass: "carousel-item text-center",
                  class: { active: index === 0 }
                },
                [
                  index == 0
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: "#imagelightbox",
                            "data-toggle": "modal"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showLightbox(image.url)
                            }
                          }
                        },
                        [
                          _c(
                            "picture",
                            {
                              ref: "ksSingle",
                              refInFor: true,
                              staticClass: "lazy-picture prop-1-1"
                            },
                            [
                              _c("source", {
                                attrs: {
                                  srcset: image.urlSecondPreview + ".avif",
                                  type: "image/avif"
                                }
                              }),
                              _vm._v(" "),
                              _c("source", {
                                attrs: {
                                  srcset: image.urlSecondPreview + ".webp",
                                  type: "image/webp"
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "d-block mx-auto mw-100",
                                attrs: {
                                  src: image.urlSecondPreview,
                                  alt: _vm.alternate,
                                  title: _vm.getItemName(),
                                  itemprop: "image",
                                  width: "650",
                                  height: "650"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    : _c(
                        "a",
                        {
                          attrs: {
                            href: "#imagelightbox",
                            "data-toggle": "modal"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showLightbox(image.url)
                            }
                          }
                        },
                        [
                          _c(
                            "picture",
                            {
                              staticClass:
                                "lazy-picture prop-1-1 lazy-bootstrap",
                              on: {
                                click: function($event) {
                                  return _vm.showLightbox(image.url)
                                }
                              }
                            },
                            [
                              _c("source", {
                                attrs: {
                                  srcset: image.urlSecondPreview + ".avif",
                                  type: "image/avif"
                                }
                              }),
                              _vm._v(" "),
                              _c("source", {
                                attrs: {
                                  srcset: image.urlSecondPreview + ".webp",
                                  type: "image/webp"
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "d-block mx-auto mw-100",
                                attrs: {
                                  "data-src": image.urlSecondPreview,
                                  alt: _vm.alternate,
                                  title: _vm.getItemName(),
                                  itemprop: "image",
                                  width: "650",
                                  height: "650"
                                }
                              })
                            ]
                          )
                        ]
                      )
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.allImagesForPicture.length > 1
            ? _c(
                "a",
                {
                  staticClass: "carousel-control-prev click-helper",
                  attrs: {
                    href: "#singleItemCarousel",
                    role: "button",
                    "data-slide": "prev"
                  }
                },
                [
                  _c("span", {
                    staticClass: "fa fa-chevron-left",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [_vm._v("Previous")])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.allImagesForPicture.length > 1
            ? _c(
                "a",
                {
                  staticClass: "carousel-control-next click-helper",
                  attrs: {
                    href: "#singleItemCarousel",
                    role: "button",
                    "data-slide": "next"
                  }
                },
                [
                  _c("span", {
                    staticClass: "fa fa-chevron-right",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [_vm._v("Next")])
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "ol",
        { staticClass: "carousel-indicators" },
        [
          _vm._l(_vm.allImagesForPicture, function(image, index) {
            return _vm.allImagesForPicture.length > 1
              ? [
                  _c(
                    "li",
                    {
                      key: image.id,
                      staticClass: "click-helper",
                      attrs: {
                        "data-target": "#singleItemCarousel",
                        "data-slide-to": index
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "singleItemPreview",
                        attrs: {
                          src: image.urlPreview,
                          alt: _vm.alternate,
                          width: "80",
                          height: "80"
                        }
                      })
                    ]
                  )
                ]
              : _vm._e()
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }